import { Button } from "@covertree/ui";

interface ProceedButtonProps {
  onContinue(): void;
}

export function ProceedButton({ onContinue }: ProceedButtonProps) {
  return (
    <Button
      fullWidth
      sx={{
        position: { xs: "fixed", md: "static" },
        minWidth: "225px",
        maxWidth: { xs: "280px", md: "100%" },
        mt: { xs: 0, md: 2 },
        mb: { xs: 1, md: 0 },
        transform: { xs: "translate(-50%)", md: "none" },
        bottom: 0,
        left: "50%",
        zIndex: 1,
      }}
      type="submit"
      onClick={onContinue}
      data-testid="looks-good-proceed-button">
      Looks good, Proceed
    </Button>
  );
}
